import {
    GET_ALL_PACKAGE,
    GET_ADD_PACKAGE,
    GET_EDIT_PACKAGE,
    GET_DELETE_PACKAGE,
    GET_PACKAGE_MENU,
    SUCCESS_MESSAGE_PACKAGE,
    ERROR_MESSAGE_PACKAGE,
    HIDE_MESSAGE_PACKAGE,
} from "constants/ActionTypes";

let INIT_STATE = {
    alertMessagePackage: '',
    successMessagePackage: false,
    errorMessagePackage: false,
    packageMenu: []
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ALL_PACKAGE: {
            return {
                ...state,
                packageMenu: action.payload
            }
        }
        case GET_ADD_PACKAGE: {
            return {
                ...state,
                packageMenu: [...state.packageMenu, action.payload]
            }
        }
        case GET_PACKAGE_MENU: {
            return {
                ...state,
                packageMenu: action.payload
            }
        }
        case SUCCESS_MESSAGE_PACKAGE: {
            return {
                ...state,
                alertMessagePackage: action.payload,
                successMessagePackage: true,
            }
        }
        case ERROR_MESSAGE_PACKAGE: {
            return {
                ...state,
                alertMessagePackage: action.payload,
                errorMessagePackage: true,
            }
        }
        case HIDE_MESSAGE_PACKAGE: {
            return {
                ...state,
                alertMessagePackage: '',
                errorMessagePackage: false,
                successMessagePackage: false,
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./reducers/Packages.js